import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Background } from './Stripe.styled';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StripeContext = ({ children }) => (
  <Elements stripe={stripePromise}>
    <Background />
    {children}
  </Elements>
);

export default StripeContext;
